/**
 * Determines which fonts should be preloaded for a specific page.
 * Add new entries to FONT_PRELOAD_RULES when a page needs critical font preloads.
 */

type FontPreloadRule = {
  match: (cmsUri: string, siteHandle: string) => boolean
  fonts: string[]
}

const FONT_PRELOAD_RULES: FontPreloadRule[] = [
  {
    match: (cmsUri, siteHandle) => cmsUri === '__home__' && siteHandle === 'delightAi_en_US',
    fonts: [
      '/fonts/serrif/Serrif-Medium.woff2',
      '/fonts/helvetica-now-text/HelveticaNowText-Regular.woff2',
    ],
  },
  {
    match: (cmsUri, siteHandle) => cmsUri === '__home__' && siteHandle === 'delightAi_ko_KR',
    fonts: [
      '/fonts/Pretendard/web/static/woff2/Pretendard-Regular.woff2',
      '/fonts/Pretendard/web/static/woff2/Pretendard-Medium.woff2',
    ],
  },

  // Add more page rules here, e.g.:
  // {
  //   match: (cmsUri, siteHandle) => cmsUri === 'industries/b2b' && siteHandle === 'delightAi_en_US',
  //   fonts: [
  //     '/fonts/helvetica-now-text/HelveticaNowText-Regular.woff2',
  //     '/fonts/helvetica-now-text/HelveticaNowText-Medium.woff2',
  //   ],
  // },
]

export function getFontPreloads(
  cmsUri: string,
  siteHandle: string
): Array<{ href: string; as: string; type: string; crossorigin?: string }> {
  const commonProps = {
    as: 'font' as const,
    crossorigin: 'anonymous' as const,
  }

  const getFontType = (href: string): string => {
    const ext = href.split('.').pop()?.toLowerCase()
    const typeMap: Record<string, string> = {
      woff2: 'font/woff2',
      woff: 'font/woff',
      otf: 'font/otf',
      ttf: 'font/truetype',
      eot: 'application/vnd.ms-fontobject',
    }
    return typeMap[ext || ''] || 'font/woff2'
  }

  const rule = FONT_PRELOAD_RULES.find(({ match }) => match(cmsUri, siteHandle))
  const fonts = rule?.fonts ?? []

  return fonts.map((href) => ({
    href,
    type: getFontType(href),
    ...commonProps,
  }))
}
